import React, { useState, useEffect } from 'react';
import BudgetTable from './BudgetTable0';
import { getBudgets } from '../../flux/actions/budgetActions';
import { getSocietes } from '../../flux/actions/societeActions';
import { getSummaryProjectBudget0, clearVentes } from '../../flux/actions/venteActions';
import { getSummaryProjectAssociationsBudget0, clearAssociations } from '../../flux/actions/associationActions';
import { Container, Row, Col, Label, CustomInput } from 'reactstrap';

import { connect } from 'react-redux';
import { IBudgetContainer0, IBudgetReduxProps0 } from '../../types/interfaces';
import Select from 'react-select';
import LoadingPage from '../../pages/loading';
import { constants } from '../../types/constants'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faBoxOpen, faUsers, faDesktop, faBullseye, faCaretLeft, faCaretRight, faWallet, faChartArea } from '@fortawesome/free-solid-svg-icons'
import Loading from '../Loading';

const BudgetContainerComponent = ({
  getBudgets,
  getSocietes,
  getSummaryProjectBudget0,
  clearVentes,
  getSummaryProjectAssociationsBudget0,
  clearAssociations,
  budget,
  societe,
  vente,
  association,
  auth
 }: IBudgetContainer0) => {

  const { budgets, loading: loadingB } = budget;
  const { societes, loading: loadingS } = societe;
  const { ventes, loading } = vente;
  const { associations, loading: loadingA } = association;
  const [ventesAndAssociations, setVentesAndAssociations] = useState<any[]>([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))].sort((a, b) => {
    if(!a.createdAt && !b.createdAt)
      return 0
    else if(!a.createdAt)
      return 1
    else if(!b.createdAt)
      return -1
    else
      return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
  }));
  const [tableData, setTableData] = useState<any[]>([]);
  const [calculateParts, setCalculateParts] = useState(false);
  const projectDetails = societes.filter(e => e.LIBELE !== "CM3" && e.LIBELE !== "CM3 SOCIAL").map(e => ({projectName: e.LIBELE, projectId: e.id, projectVentes: ventesAndAssociations.filter(t => (t.isAssLine ? t.contrat : t)?.PROJET === e.LIBELE)}));
  const cumulOptions = [{value: "MONTHLY", label: "Mensuel"}, {value: "CUMUL", label: "Cumulé"}];
  const [cumulValue, setCumulValue] = useState<any>(cumulOptions.find(e => e.value === "MONTHLY"));
  const titledOptions = [{value: "ALL", label: "Tout"}, {value: "TITLED", label: "Titrés"}, {value: "UNTITLED", label: "Non titrés"}];
  const [titledValue, setTitledValue] = useState<any>(titledOptions.find(e => e.value === "ALL"));
  const sNotaireOptions = [{value: "NOT YET", label: "Pas encore signé"}, {value: "CHEZ", label: "Signé client"}, {value: "EN COURS", label: "Signature en cours"}, {value: "SIGNE", label: "Signé notaire"}];
  const [sNotaireValues, setSNotaireValues] = useState<any[]>(sNotaireOptions.filter(e => ["NOT YET", "CHEZ", "EN COURS", "SIGNE"].includes(e.value)));
  const today = new Date();
  const [yearValue, setYearValue] = useState<any>(today.getFullYear());
  
  useEffect(() => {
    getBudgets();
  }, [getBudgets]);

  useEffect(() => {
    auth && auth.user && getSocietes(auth?.user.societes?.map(e => e.id) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
  }, [getSocietes, auth]);

  useEffect(() => {
    clearVentes();
    clearAssociations();
    if(auth?.user){
      getSummaryProjectBudget0((titledValue || titledOptions[1]).value, calculateParts ? 1 : 0);
      if(calculateParts)
        getSummaryProjectAssociationsBudget0((titledValue || titledOptions[1]).value);
    }
  }, [auth, calculateParts, titledValue]);

  useEffect(() => {
    return () => {
      clearVentes();
      clearAssociations();
    }
  }, []);

  const getVentesFromMonth = (ventesAndAssociations, month, year) => {
    return ventesAndAssociations.filter(e => {
      const createdAt = e.isAssLine ? e.originalDate : e.DATE_RESERV;
      return createdAt && (new Date(createdAt).getMonth() + 1) === month && (new Date(createdAt).getFullYear()) === year
    })
  }

  useEffect(() => {
    setVentesAndAssociations([...ventes, ...associations.map(e => ({...e, vente: e.contrat, isAssLine: true}))]
    .filter(e => sNotaireValues.some(e => e.value === "NOT YET") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || !!(e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]) || !!(e["isAssLine"] ? e["contrat"]?.chez_notaire : e["chez_notaire"]))
    .filter(e => sNotaireValues.some(e => e.value === "CHEZ") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || (e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]) || !(e["isAssLine"] ? e["contrat"]?.chez_notaire : e["chez_notaire"]))
    .filter(e => sNotaireValues.some(e => e.value === "EN COURS") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) === constants.STATUT_SIGNE_NOTAIRE || !(e["isAssLine"] ? e["contrat"]?.en_cours_signature : e["en_cours_signature"]))
    .filter(e => sNotaireValues.some(e => e.value === "SIGNE") || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) !== constants.STATUT_SIGNE_NOTAIRE)
      // .filter(e => includeSigneNotaire || (e["isAssLine"] ? e["contrat"]?.bien?.STATUT : e["bien"]?.STATUT) !== constants.STATUT_SIGNE_NOTAIRE)
      .filter(e => (e["isAssLine"] ? e["contrat"]?.PROJET : e.PROJET) !== "CM3" && (e["isAssLine"] ? e["contrat"]?.PROJET : e.PROJET) !== "CM3 SOCIAL")
      .sort((a, b) => {
      if(!a.createdAt && !b.createdAt)
        return 0
      else if(!a.createdAt)
        return 1
      else if(!b.createdAt)
        return -1
      else
        return a.createdAt > b.createdAt ? -1 : a.createdAt < b.createdAt ? 1 : 0
    }))
  }, [ventes, associations, sNotaireValues]);

  useEffect(() => {
    setTableData(projectDetails.map(n => ({
      projectId: n.projectId,
      projectName: n.projectName,
      ...constants.DP_MONTHS.map((e, i) => ({
        ...(cumulValue?.value === "CUMUL" ? {
          sPrixNet: Array.from(Array(i + 1), (_, iA) => iA + 1).reduce((e, t) => e + getVentesFromMonth(n.projectVentes, t, yearValue).reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0), 0),
          sEncaissements: Array.from(Array(i + 1), (_, iA) => iA + 1).reduce((e, t) => e + getVentesFromMonth(n.projectVentes, t, yearValue).reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.PART || 0), 0) || 0), 0), 0),
          goalE: Array.from(Array(i + 1), (_, iA) => iA + 1).reduce((e, t) => e + (budgets.find(e => e.month === t && e.year === yearValue && e.societeId === n.projectId)?.goalE || 0), 0),
          goalV: Array.from(Array(i + 1), (_, iA) => iA + 1).reduce((e, t) => e + (budgets.find(e => e.month === t && e.year === yearValue && e.societeId === n.projectId)?.goalV || 0), 0),
          id: budgets.find(e => e.month === (i + 1) && e.year === yearValue && e.societeId === n.projectId)?.id,
          comment: budgets.find(e => e.month === (i + 1) && e.year === yearValue && e.societeId === n.projectId)?.comment,
        } : {
          sPrixNet: getVentesFromMonth(n.projectVentes, i + 1, yearValue).reduce((e, t) => e + ((t.isAssLine ? t.PRIX_VENTE : t.PRIX_NET) || 0), 0),
          sEncaissements: getVentesFromMonth(n.projectVentes, i + 1, yearValue).reduce((e, t) => e + (t.contrat_encaissements?.reduce((e, t) => e + (t.PART || 0), 0) || 0), 0),
          ...budgets.find(e => e.month === (i + 1) && e.year === yearValue && e.societeId === n.projectId),
        }),
        month: i + 1,
        year: yearValue,
      })).reduce((e, t, i) => ({...e, [String(t.month)]: t}), {})
    })))
  }, [societes, ventesAndAssociations, budgets, yearValue, cumulValue])
  
  const handleCumulChange = data => {
    setCumulValue(data || '');
  }

  const changeCalculatePartsHandle = (e) => {
    setCalculateParts(e.target.checked);
  };

  const handleTitledChange = data => {
    setTitledValue(data || '');
  }
  const handleSNotaireChange = data => {
    setSNotaireValues(data?.length ? data : []);
  }
  
  return loadingB ? <LoadingPage/> : (
    <>
      <Container>
        <Row>
          <Col xs="12" lg="6"><h3 className="title"><FontAwesomeIcon icon={faChartArea} />&nbsp;&nbsp;Tableau du budget</h3></Col>
          <Col xs="12" lg="6" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="cumul">Affichage : </Label>
            </div>
            <Select
              id="cumul"
              className="reactselect"
              classNamePrefix="react-select"
              defaultValue={cumulOptions.find(e => e.value === "MONTHLY")}
              value={cumulValue}
              onChange={handleCumulChange}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={false}
              options={cumulOptions}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="12" lg="6" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="snotaire">Statut notaire : </Label>
            </div>
            <Select
              id="snotaire"
              className="reactselect"
              classNamePrefix="react-select"
              isMulti
              value={sNotaireValues?.map(e => ({label: e.label, value: e.value})) || []}
              // value={{value: societeValue.value, label: societeValue.label}}
              onChange={handleSNotaireChange}
              placeholder={'Chercher...'}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={true}
              options={sNotaireOptions}
              menuContainerStyle={{ zIndex: 9999999 }}
            />
          </Col>
          <Col xs="12" lg="3" className="listPageFilterSelect">
            <div className="listPageFilterTitle" style={{padding: "0 8px"}}>
              <Label for="titled">Titrés : </Label>
            </div>
            <Select
              id="titled"
              className="reactselect"
              classNamePrefix="react-select"
              defaultValue={titledOptions[1]}
              value={titledValue}
              // value={{value: societeValue.value, label: societeValue.label}}
              onChange={handleTitledChange}
              isClearable={false}
              loadingMessage={() => 'Chargement...'}
              noOptionsMessage={() => 'pas de resultat'}
              isSearchable={false}
              options={titledOptions}
            />
          </Col>
          <Col xs="12" lg="3" className="fullFlexCenter text-lg-center justify-content-center justify-content-lg-end">
            <CustomInput type="switch" id="showAllAssociations" name="showAllAssociationsSwitch" label="Ne prendre en compte que les parts vendues si association" checked={calculateParts} onChange={changeCalculatePartsHandle} />
          </Col>
        </Row>
      </Container>
      <div className="fullFlexCenter">
        <div className="fullFlexCenter"><FontAwesomeIcon icon={faCaretLeft} className="goalCalendarYearCarets" onClick={() => setYearValue(e => Number(e) - 1)} title={`${Number(yearValue) - 1}`} /></div>
        <div className="goalCalendarYear">{yearValue}</div>
        <div className="fullFlexCenter"><FontAwesomeIcon icon={faCaretRight} className="goalCalendarYearCarets" onClick={() => setYearValue(e => Number(e) + 1)} title={`${Number(yearValue) + 1}`} /></div>
      </div>
      {loading || loadingA ? <Loading topSpace /> : <BudgetTable linesData={tableData} budgets={budgets} />}
    </>
  );
};

const mapStateToProps = (state: IBudgetReduxProps0) => ({
  budget: state.budget,
  societe: state.societe,
  vente: state.vente,
  association: state.association,
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { getBudgets, getSocietes, getSummaryProjectBudget0, clearVentes, getSummaryProjectAssociationsBudget0, clearAssociations })(BudgetContainerComponent);
